import TimeTaxSupportSystemClient from '../../../system';
import { DateTime } from 'luxon';
import MessageCourier from '../../../lib/MessageCourier';
import { IReporteHorasCumplimientoGeneral } from '../../../system/reporting/ReportingSystem';
import { useTranslation } from 'react-i18next';
import DataGrid, {
  Scrolling,
  Column,
  Summary,
  SortByGroupSummaryInfo,
  Export,
  SearchPanel,
  TotalItem,
} from 'devextreme-react/data-grid';

import { User } from '../../../system/User';
import { EscalableExporterOptions, exportToExcel } from '../../../lib/Util';
import Button from 'devextreme-react/button';
import useIsMobile from '../../../common/custom-hooks/useIsMobile';
import { IorganizationLevels } from '../../../system/AuthenticationSystem';
import InfoHourDecimalTooltip from '../../../shared/components/InfoHourDecimalTooltip';

interface IReportingSettlementHoursSector {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  user: User;
  items: IReporteHorasCumplimientoGeneral[];
  from: DateTime;
  to: DateTime;
  resetTableAfterExport: () => void;
  levelsN: IorganizationLevels[]
}


export const ReportHoursSectorCumplimientoGeneral = (props: IReportingSettlementHoursSector) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useIsMobile();

  const onExportingCumplimientoGeneral = async (e: any) => {
    let options: EscalableExporterOptions = {
      fileName: `cumplimiento-general-de-horas-sector-de-${props.from?.toFormat(
          'dd-LL-yyyy'
      )}-a-${props.to?.toFormat('dd-LL-yyyy')}`,
      sheetName: t('Cumplimiento general de horas por sector'),
    };
    await exportToExcel(e, options);
    props.resetTableAfterExport();
  };

  return (
      <>
        <Button
            className="btn-dinamic-table"
            icon="help"
            hint="Si la cantidad de colaboradores es mayor a la esperada, probablemente se
          debe a colaboradores con más de un cargo. Los números son relativos a la cantidad de cargos distintos."
        />
        <DataGrid
            height={620}
            width="100%"
            keyExpr={props.levelsN[0].nio_nombre_tec}
            dataSource={props.items}
            showBorders={true}
            wordWrapEnabled={true}
            onExporting={onExportingCumplimientoGeneral}
            columnAutoWidth={true}
            columnHidingEnabled={false}
        >
          <SearchPanel visible={true} placeholder={t('Buscar...')} />
          <Scrolling mode="virtual" showScrollbar="always" useNative={false}  />
          <Column dataField={props.levelsN[0].nio_nombre_tec} width={ isMobile ? 250 : 650}  caption={t(props.levelsN[0].nio_nombre)}/>
          <Column dataField="cant_colaboradores" caption={t("# Colaboradores")} />
          <Column 
            dataField="horas_cargadas_totales"
            headerCellRender={() => {
              return (
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}} >
                  {t("Horas confirmadas")}
                  <InfoHourDecimalTooltip />
                </div>
              )
            }}
          />
          <Column 
            dataField="horas_esperadas_totales"
            headerCellRender={() => {
              return (
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}} >
                  {t("Horas esperadas")}
                  <InfoHourDecimalTooltip />
                </div>
              )
            }}
          />
          <Column dataField="porcentaje_cumplimiento" caption={t("% de cumplimiento")} />
          <Summary>
            <TotalItem
                column="cant_colaboradores"
                summaryType="sum"
                valueFormat={(d) => parseFloat(d)}
                displayFormat={`{0}`}
            />

            <TotalItem
                column="horas_cargadas_totales"
                summaryType="sum"
                valueFormat={(d) => parseFloat(d).toFixed(2)}
                displayFormat={`{0}`}
            />
            <TotalItem
                column="horas_esperadas_totales"
                summaryType="sum"
                valueFormat={(d) => parseFloat(d).toFixed(2)}
                displayFormat={`{0}`}
            />
          </Summary>
          <SortByGroupSummaryInfo sortOrder={'desc'} summaryItem="sum" />
          <Export enabled={true} />
        </DataGrid>
      </>
  );
};
